import { t } from "i18next";
import DropDownFilterCell from "../../../components/GridCell/GridDropDownFilterCell";

export const eventParticipantGridColumns = [
  {
    field: "etkinliK_KATILIMCI_ID",
    title_key: "participant_number",
    width: "100px",
    filterable: false,
  },
  {
    field: "dkN_SICIL_NO",
    title_key: "registration_number",
    width: "200px",
    filterable: true,
  },
  {
    field: "ad",
    title_key: "name",
    width: "200px",
    filterable: true,
  },
  {
    field: "soyad",
    title_key: "surname",
    width: "200px",
    filterable: true,
  },
  {
    field: "email",
    title_key: "email",
    width: "200px",
    filterable: true,
  },
  {
    field: "maiL_GONDERILDI",
    title_key: "is_send_mail",
    width: "200px",
    filterable: true,
    filterCell: (props) => (
      <DropDownFilterCell
        data={[
          { value: "EVET", text: t("yes") },
          { value: "HAYIR", text: t("no") },
        ]}
        {...props}
      />
    ),
    cell: (props) => {
      return <td>{t(props.dataItem.maiL_GONDERILDI)}</td>;
    },
  },
  {
    field: "daveT_GONDERILDI",
    title_key: "is_send_invitation",
    width: "200px",
    filterable: true,
    filterCell: (props) => (
      <DropDownFilterCell
        data={[
          { value: "EVET", text: t("yes") },
          { value: "HAYIR", text: t("no") },
        ]}
        {...props}
      />
    ),
    cell: (props) => {
      return <td>{t(props.dataItem.daveT_GONDERILDI)}</td>;
    },
  },
  {
    field: "katiliM_DURUMU",
    title_key: "participation_status",
    width: "200px",
    filterable: true,
    filterCell: (props) => (
      <DropDownFilterCell
        {...props}
        data={[
          { text: t("will_participate"), value: "EVET" },
          { text: t("will_not_participate"), value: "HAYIR" },
          { text: t("tentative"), value: "BELIRSIZ" },
          { text: t("did_not_answer"), value: "NULL", operator: "isnull" },
        ]}
      />
    ),
    cell: (props) => {
      var { dataItem, field } = props;
      var color =
        dataItem[field] === "EVET"
          ? "#2979FF"
          : dataItem[field] === "HAYIR"
          ? "#FF5252"
          : dataItem[field] === "BELIRSIZ"
          ? "#fcc95dff"
          : "#9E9E9E";
      var text =
        dataItem[field] === "EVET"
          ? t("will_participate")
          : dataItem[field] === "HAYIR"
          ? t("will_not_participate")
          : dataItem[field] === "BELIRSIZ"
          ? t("tentative")
          : t("did_not_answer");
      return (
        <td
          {...props.tdProps}
          colSpan={1}
          style={{
            color: color,
            fontWeight: "bold",
          }}
        >
          {text}
        </td>
      );
    },
  },
];
